import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Heart, Zap, Calendar, Smartphone } from 'lucide-react';
import { useApp } from '../context/AppContext';

export default function ActivityCard({ activity, variant = 'default' }) {
  const { wishlist, toggleWishlist } = useApp();
  const fav = wishlist.includes(activity.id);

  return (
    <Link to={`/activity/${activity.id}`} className="activity-card block bg-white rounded-xl overflow-hidden border border-gray-100">
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={activity.image} alt={activity.title} loading="lazy" className="w-full h-full object-cover" />
        {activity.badge && (
          <div className="absolute top-2 left-2 pill" style={{ background: '#fff', color: '#ff5b00' }}>
            {activity.badge}
          </div>
        )}
        <button
          onClick={(e) => { e.preventDefault(); toggleWishlist(activity.id); }}
          className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/90 hover:bg-white flex items-center justify-center shadow-sm"
          aria-label="Save"
        >
          <Heart className={`w-4 h-4 ${fav ? 'fill-red-500 text-red-500' : 'text-gray-700'}`} />
        </button>
        {activity.originalPrice && (
          <div className="absolute bottom-2 left-2 pill" style={{ background: '#ff5b00', color: '#fff' }}>
            Save ${activity.originalPrice - activity.price}
          </div>
        )}
      </div>
      <div className="p-3">
        <div className="text-[11px] text-gray-500 mb-1">{activity.city}</div>
        <h3 className="text-sm font-semibold text-gray-900 line-clamp-2 min-h-[40px]">{activity.title}</h3>
        <div className="flex items-center gap-1 mt-1.5 text-xs">
          <Star className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />
          <span className="font-semibold text-gray-900">{activity.rating}</span>
          <span className="text-gray-500">({activity.reviews.toLocaleString()})</span>
        </div>
        <div className="flex items-center gap-1 mt-2 flex-wrap">
          {activity.instant && <span className="text-[10px] text-gray-600 inline-flex items-center gap-0.5"><Zap className="w-3 h-3" /> Instant</span>}
          {activity.mobileVoucher && <span className="text-[10px] text-gray-600 inline-flex items-center gap-0.5"><Smartphone className="w-3 h-3" /> Mobile</span>}
          {activity.flexible && <span className="text-[10px] text-gray-600 inline-flex items-center gap-0.5"><Calendar className="w-3 h-3" /> Flexible</span>}
        </div>
        <div className="mt-2 flex items-baseline gap-1">
          <span className="text-[11px] text-gray-500">from</span>
          <span className="text-lg font-extrabold" style={{ color: '#ff5b00' }}>${activity.price}</span>
          {activity.originalPrice && <span className="text-[11px] text-gray-400 line-through">${activity.originalPrice}</span>}
        </div>
      </div>
    </Link>
  );
}
